<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Firmar Reporte Mensual Mensual&nbsp
        .columns
          .column
            span
              CardDataResumen(:tarjeta="tarjetaReporte" :data="resumen")
        .columns
          .column
            Signature(@saveFile="checkFile" @sigWebStatus="sigWebStatus")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import CardDataResumen from './componentes/CardDataResumen'
  import Signature from '../inventario_Componentes/Signature.vue'

  import InventarioServices from '@/services/inventario/inventario'

  import { mapState } from 'vuex'

  export default {
    name: 'FirmarReporteMensual',
    components: { NavBar, Loader, CardDataResumen, Signature },
    data() {
      return {
        isLoading: true,
        tarjetasUser: [],
        tarjetaReporte: {},
        nombreFile: '',
        firma: '',
        resumen: {}
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerData()
      },
      obtenerData() {
        console.log(this.combustible_Reporte_firmar.id_tarjeta)
        InventarioServices.getResumenesData(this.combustible_Reporte_firmar.id_usuario, this.combustible_Reporte_firmar.periodo, this.combustible_Reporte_firmar.id_tarjeta)
          .then((data) => {
            this.resumen = data[0]
            switch (parseInt(this.resumen.estado)) {
              case 0:
                this.nombreFile = `firma_realiza_${this.resumen.id}`
                break
              case 1:
                this.nombreFile = `firma_revisa_${this.resumen.id}`
                break
              case 2:
                this.nombreFile = `firma_autoriza_${this.resumen.id}`
                break
              case 3:
                this.nombreFile = `firma_autoriza_${this.resumen.id}`
                break
            
              default:
                this.nombreFile = `No firma`
                break
            }
            this.obtenerDataTarjeta()
          })
          .catch((e) => console.log(e))
      },
      obtenerDataTarjeta() {
        InventarioServices.getArticulosInd(this.resumen.id_tarjeta)
          .then((data) => {
            this.tarjetaReporte = data.data[0]
            //this.obtenerDataVehiculo()
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },
      obtenerDataVehiculo() {
        InventarioServices.getArticulosInd(this.resumen.id_vehiculo)
          .then((data) => {
            this.vehiculoReporte = data.data[0]
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },
      checkFile (file) {
        console.log(file)
        this.firma = file
        
        if (this.firma !== 'NoData') {
          InventarioServices.FirmarResumen(this.resumen.id, this.resumen.estado, this.firma, this.nombreFile)
            .then( data => {
              console.log(data)
              const tema = data.success ? 'toasted-primary' : 'bubble'
              const icon = data.success ? 'done' : 'ban'
              this.displayToast(tema, data.respuesta, icon, 'OK')
              if (data.success) {
                this.backResumenes()
              }
            })
            .catch( e => console.log(e))
        } else {
          console.log('No Guardar la Firma')
          this.displayToast('bubble', 'Error: No se ha firmado aún la salida.', 'ban', 'OK')
        }
      },
      backResumenes () {
        this.$store.commit('firmarReporte', {})
        this.$router.push('/Combustible')
      },

      sigWebStatus (val) {
        console.log(val)
        const tema = val ? 'toasted-primary' : 'bubble'
        const text = val ? 'sigWeb instalado' : 'No está instalado sigWeb'
        const icon = val ? 'done' : 'ban'
        this.displayToast(tema, text, icon, 'Ok' )
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'combustible_Reporte_firmar'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/FirmarReporteMensual.vue